// extracted by mini-css-extract-plugin
export default {"zoomModal":"v4-z","image":"w4-z","button":"x4-z","isOverlayShown":"y4-z"};